module.exports = __webpack_public_path__ + "media/images/featured-2-mobile-6d39d4a7a93f637e801808feb0ad0c89.webp";